import React from "react";
import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { Grid, TextField, Button } from "@mui/material";
import { MDBBtn } from "mdb-react-ui-kit";

import { validateToken } from "../../services/login-service";
import { resetPassword } from "../../services/login-service";

import "./login.css";

const ResetPassword = () => {

    const location = useLocation();
    const navigate = useNavigate();

    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get("token");
    const userId = searchParams.get("id");
    
    const [isValidToken, setIsValidToken] = useState(false);
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");
    const [passwordInput, setPasswordInput] = useState({
      password: "",
      retypePassword: "",
    });

    useEffect(() => {
      const verifyToken = async () => {
        try {
          console.log("trying to validate the token...")
          await validateToken(token, userId);
          console.log("token validated")
          setIsValidToken(true);
        } catch (error) {
          console.log("token validation failed")
          setErrorMessage(
            error.response?.data.message || "Invalid token or user ID"
          );
        } finally {
          setLoading(false);
        }
      };
      verifyToken();
    }, [token, userId]);

    const setRegister = (event) => {
      navigate('/register')
    };
  
    if (loading) {
      return <div>Loading...</div>;
    }
  
    if (!isValidToken) {
      return <div style={{textAlign: "center"}}>
          <p style={{color: "red", margin: "15px"}}>{errorMessage}</p>
          <Button  onClick={ () => { navigate('/forget-password')}}> Forgot password</Button>
      </div>;
    }
  
    const handleInput = (event) => {
      const { name, value } = event.target;
      setPasswordInput({
        ...passwordInput,
        [name]: value,
      });
    };
  
    const handleSubmit = async (event) => {
      event.preventDefault();
      const { password, retypePassword } = passwordInput;
  
      if (password !== retypePassword) {
        setErrorMessage("Passwords do not match.");
        return;
      }

      const resetData = {
        token,
        userId,
        newPassword: password,
      };
  
      try {
        await resetPassword(resetData);
        // Handle success - you might want to redirect the user or show a success message
        navigate("/login")
      } catch (error) {
        setErrorMessage(
          error.response?.data.message || "Failed to reset password"
        );
      }
    };

  return (
    <div className="login-window">

      <Link to="/" className="unstyled-link">
        <div className="login-header">
          <img
            className="login-page-logo"
            src="logo/ST_OneLine_RGB.png"
            alt="our logo"
          ></img>
          <h3 className="login-page-logo-tagline">
            Open supply chain intelligence for a just world
          </h3>
        </div>
      </Link>

      <div
        style={{ textAlign: "left", marginBottom: "1.5rem", color: "#0062b2" }}
      >
        <h4>Reset Password</h4>
      </div>

      <form onSubmit={handleSubmit}>
        <Grid container alignItems="center" direction="column" spacing={3}>

          <Grid item xs={6} className="wd-login-item">
            <label htmlFor="new_password" style={{ margin: 0 }}>New Password</label>
            <TextField
              id="new_password"
              fullWidth
              required
              aria-label="username text box"
              name="password"
              type="password"
              // label="New Password"
              onChange={handleInput}
            />
          </Grid>

          <Grid item xs={6} className="wd-login-item">
            <label htmlFor="retype_password" style={{ margin: 0 }}>Retype Password</label>
            <TextField
              id="retype_password"
              required
              fullWidth
              aria-label="password text box"
              name="retypePassword"
              // label="Retype Password"
              type="password"
              onChange={handleInput}
            />
          </Grid>

          <Grid item xs={12} className="login-full-width">
            {
              errorMessage && (
                <p style={{ color: "red", marginTop: "15px" }}>{errorMessage}</p>
              )
            }
            <Button
              className="wd-submit-btn-login"
              variant="contained"
              aria-label="submit button"
              onClick={handleSubmit}
            >
              Reset Password
            </Button>
          </Grid>

        </Grid>
      </form>
    
      <div className="d-flex flex-row align-items-center justify-content-left pb-4 mt-4">
        <p className="mb-0 mr-2">Don't have an account?</p>
        <MDBBtn outline color="danger" onClick={setRegister}>
          Create Account
        </MDBBtn>
      </div>

    </div>
  );

};

export default ResetPassword;
